var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShow)?_c('div',{staticClass:"app-store"},[_c('a',{attrs:{"href":_vm.link}},[_c('img',{attrs:{"src":"/images/app-store.svg","alt":"Download on the App Store"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }